import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

import LinkableItemList from "~/modules/mapEditor/components/LinkableItemList";

import { EcologicalFunctionCard } from "../EcologicalFunctionCard";
import { MapEditorObservationPanelEcologicalFunctionFragment } from "../EcologicalFunctionCard/fragments.generated";

export interface LinkedEcologicalFunctionsProps {
    createTo: (element: MapEditorObservationPanelEcologicalFunctionFragment) => string;
    elements: MapEditorObservationPanelEcologicalFunctionFragment[];
    onUnlinkClick?: (ecologicalFunctionId: string) => void;
}

export function LinkedEcologicalFunctions({ createTo, elements, onUnlinkClick }: LinkedEcologicalFunctionsProps) {
    const { t } = useTranslation("mapEditor");

    return (
        <>
            <Divider>{t("ecologicalFunctionLinking.dividerLinkedFunctions")}</Divider>
            <LinkableItemList
                clickable
                createTo={createTo}
                items={elements}
                renderCard={element => (
                    <EcologicalFunctionCard
                        key={element.id}
                        ecologicalFunction={element}
                        isLinked={true}
                        onUnlinkClick={onUnlinkClick}
                    />
                )}
            />
        </>
    );
}
